import type { ReactNode } from "react";

import clsx from "clsx";

type WizardFooterProps = {
  /**
   * Stacks the footer's buttons full-width instead of the desktop
   * right-aligned inline row — canvas's
   * `.wiz-shell--mobile .wiz-foot__right { flex-direction: column-reverse;
   * width: 100% }`. Every caller passes its secondary action(s) (Back /
   * Cancel) first and the primary action last, matching the canvas's own DOM
   * order — `column-reverse` is what puts the primary button on top once
   * stacked.
   */
  isMobile?: boolean;
  children: ReactNode;
};

export const WizardFooter = ({ isMobile, children }: WizardFooterProps) => (
  <div
    className={clsx(
      // w-full unconditionally: some steps' wrapper sets `items-start`
      // (shrink-to-content), which would otherwise stop this from
      // spanning the full width it needs on mobile.
      "flex w-full",
      isMobile
        ? "mt-auto flex-col-reverse items-stretch gap-2 [&>*]:w-full"
        : "justify-end gap-4",
    )}
  >
    {children}
  </div>
);
